
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[lang]/[...modelPath]",
      function () {
        return require("private-next-pages/[country]/[lang]/[...modelPath].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[lang]/[...modelPath]"])
      });
    }
  